import testimonialsHeroBg from "../assets/Testimonialhero.png";
import HomeStudentsTestimonials from "../components/home/HomeStudentsTestimonials";

function Testimonials() {
  return (
    <div className="bg-white">
      <section
        className="relative isolate flex min-h-[180px] items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat sm:min-h-[200px] md:min-h-[220px]"
        style={{ backgroundImage: `url(${testimonialsHeroBg})` }}
        aria-labelledby="testimonials-hero-heading"
      >
        <div
          className="absolute inset-0 bg-gradient-to-r from-ink/70 via-ink/50 to-ink/35"
          aria-hidden
        />
        <div className="relative z-10 mx-auto max-w-7xl px-4 py-6 text-center sm:px-8 sm:py-8 md:px-10 lg:px-8">
          <h1
            id="testimonials-hero-heading"
            className="text-3xl font-semibold tracking-tight text-white sm:text-4xl md:text-5xl"
          >
            Testimonials
          </h1>
        </div>
      </section>

      <HomeStudentsTestimonials backgroundClassName="bg-white" />
    </div>
  );
}

export default Testimonials;
